import { render, staticRenderFns } from "./seating-a45.vue?vue&type=template&id=967ace38"
import script from "./seating-a45.vue?vue&type=script&lang=js"
export * from "./seating-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports